import type { FC } from 'react'

import { Radio, RadioGroup } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import Text from '@/app/translations/Text'

const InjuryType: FC<{ isEditable: boolean }> = ({ isEditable }) => (
  <section>
    <h3>
      <Text id="Type skade" />
    </h3>

    <RadioGroup id="injury-type">
      <Field name="injuryType">
        {({ field }: FieldProps) => (
          <Radio
            id="LOSS"
            label={<Text id="Lost" />}
            marginBottom={16}
            isDisabled={!isEditable}
            {...field}
          />
        )}
      </Field>

      <Field name="injuryType">
        {({ field }: FieldProps) => (
          <Radio
            id="THEFT"
            label={<Text id="Stolen" />}
            marginBottom={16}
            isDisabled={!isEditable}
            {...field}
          />
        )}
      </Field>

      <Field name="injuryType">
        {({ field, meta }: FieldProps) => (
          <Radio
            id="DAMAGE"
            label={<Text id="Damaged" />}
            marginBottom={16}
            isDisabled={!isEditable}
            error={meta.error}
            touched={meta.touched}
            {...field}
          />
        )}
      </Field>
    </RadioGroup>
  </section>
)

export default InjuryType
